import Quiz from "./QuizModule/components/Quiz";
import { useLocation } from 'react-router-dom';

function QuizView() {
  const location = useLocation()
  const model = location.state?.model
  const quizzes = location.state?.quizzes

  return (
    <div>
      <Quiz quiz={model} quizzes={quizzes}/>
    </div>
  )
}

export default QuizView
